export const REQUEST_HANDLER = "REQUEST_HANDLER";
export const REQUEST_SUCCESS = "REQUEST_SUCCESS";
export const REQUEST_FAILURE = "REQUEST_FAILURE";
